import React, { FC } from "react";
import clsx from "clsx";

import { ICareerFeedbackSheet } from "../../../state";
import { ReactComponent as CurrentSelfIcon } from "../../../assets/images/Career/icon_map_current_self.svg";
import { ReactComponent as FutureSelfIcon } from "../../../assets/images/Career/icon_map_future_self.svg";
import { ReactComponent as CurrentSocietyIcon } from "../../../assets/images/Career/icon_map_current_society.svg";
import { ReactComponent as FutureSocietyIcon } from "../../../assets/images/Career/icon_map_future_society.svg";

import styles from "./Map.module.scss";

type Props = {
  feedbackSheets: ICareerFeedbackSheet[];
};

const Map: FC<Props> = ({ feedbackSheets }) => {
  const iconComponents: {
    [key: number]: JSX.Element;
  } = {
    1: <CurrentSelfIcon className={styles.icon} />,
    2: <FutureSelfIcon className={styles.icon} />,
    3: <CurrentSocietyIcon className={styles.icon} />,
    4: <FutureSocietyIcon className={styles.icon} />,
  };

  return (
    <div className={styles.wrapper}>
      <ul className={styles.list}>
        {feedbackSheets.map(sheet => (
          <li
            key={sheet.issue.id}
            className={clsx(
              styles.item,
              [1, 2].includes(sheet.issue.id) && styles.self,
              [3, 4].includes(sheet.issue.id) && styles.society,
            )}
          >
            <div className={styles.header}>
              {iconComponents[sheet.issue.id]}
              <p className={styles.title}>{sheet.issue.title}</p>
            </div>
            <p className={styles.text}>{sheet.issue.content}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Map;
